import helpers from '../helpers/helpers';
import initPlayer from './init-player';

const popup = {
	createPopup: function(element) {
		helpers.disableScroll();
		const popup = document.createElement('div');
		popup.setAttribute('class', 'popup js-popup');
		popup.innerHTML = `
		<div class="popup__content js-popup-content">
		<button type="button" class="button-close popup__close js-close-popup">
		<span class="sr-only">Close popup</span>
		</button>
		<div class="popup__video js-popup-video">
		</div>
		</div>`;
		const video = element.cloneNode(true);
		const popupVideo = popup.querySelector('.js-popup-video');
		popupVideo.appendChild(video);
		document.body.append(popup);
		initPlayer(video);
		this.closePopupEventHandlers(popup);
	},

	closePopupEventHandlers: function(element) {
		const closeButton = element.querySelector('.js-close-popup');
		const escapeKey = 27;
		element.addEventListener('click', (e) => {
			if (e.target !== e.currentTarget && e.target !== closeButton) return;
			element.remove();
			helpers.enableScroll();
		});
		document.addEventListener('keydown', (e) => {
			if (e.keyCode !== escapeKey) return;
			element.remove();
			helpers.enableScroll();
		});
	}
};

export default popup;
